import _get from 'lodash/get';
import CMPageConstants from './CMPageConstants';
import RestClient from '../RestClient/RestClient';
import LoggerHelper from '../logs/LoggerHelper';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { cstToUTC } from '../Common/CommonHelper';
import { getCookie } from '../helpers/Cookies';

const { CM_INTOOL_COMP_API, CM_AGGREGATOR_API, PREV_CM_AGGREGATOR_API } = CMPageConstants;

const getPageAggregator = (data) => {
    let url = data?.aggregateAPI
        ? `${CM_AGGREGATOR_API}${data?.params}`
        : `${CM_INTOOL_COMP_API}${
              data?.params
                  ? data?.params
                  : `/${data?.type}/${data?.id}${data?.envFlag ? `?cm-env=${data?.envFlag}` : ''}${
                        data?.channel ? `&channel=${data?.channel}` : ''
                    }`
          }`;

    const context = RestClient.getContext();
    let previewDate = '';

    /*
     * if preview env and cookie is set
     * then add config val previewDate
     * FetchHelper would set the headers
     */
    /* istanbul ignore next */
    const prevAggregator = data?.aggregateAPI
        ? `${PREV_CM_AGGREGATOR_API}${data?.params}`
        : `${CM_INTOOL_COMP_API}${
              data?.params
                  ? data?.params
                  : `/${data?.type}/${data?.id}${data?.envFlag ? `?cm-env=${data?.envFlag}` : ''}${
                        data?.channel ? `&channel=${data?.channel}` : ''
                    }`
          }`;
    if (context?.isPreview) {
        const dateValue = cstToUTC(getCookie('DP_PREVIEW_DATE'), context);
        // Check for the Preview Environment Date
        previewDate = (dateValue || new Date())?.toISOString();
        url = `${prevAggregator}`; // different end point to preveiew env
    }

    const config = {
        url,
        apiHost: apiHosts.content,
        excludeVersion: true,
        isXCloudHeaderRequired: true,
        isCMHeaderRequired: true,
        credentials: 'include',
        encode: false,
        previewDate,
        cmPreviewDate: data?.previewDate,
        enableRequestHeaderCookie: true,
    };

    return RestClient.get(config)
        .then((json) => {
            const logger = LoggerHelper.getLogger();

            const responseCache = _get(json, 'headers._headers[cache-control');
            const jsonRes = {
                ...json,
                data: {
                    ...json.data,
                    yodaCacheControl: __SERVER__
                        ? _get(json, "headers._headers['x-yoda-cache-control']", [])[0]
                        : null,
                },
            };
            logger.info({
                message: 'CM API Response',
                url: `${url}`,
                timestamp: new Date(),
                cache: `${responseCache}`,
            });
            return jsonRes;
        })
        .catch(
            /* istanbul ignore next */
            (error) => {
                console.log(`request failed ${error}`);
            }
        );
};
export default getPageAggregator;
